
import { Permission } from "../../types";
import { supabase } from "@/integrations/supabase/client";

/**
 * Try to sync localStorage cache back to database when connection is restored
 */
export const syncLocalToDatabase = async (localPermissions: Permission[]): Promise<boolean> => {
  try {
    console.log("[PermissionsStorage] Attempting to sync local cache to database");
    
    // Check if database already has data
    const { data: existing, error: checkError } = await supabase
      .from('role_permissions')
      .select('id')
      .limit(1);
    
    if (checkError) {
      console.error("[PermissionsStorage] Error checking database during sync:", checkError);
      return false;
    }
    
    // Only sync if database is empty to avoid overwriting newer data
    if (!existing || existing.length === 0) {
      // Remove numeric IDs to let Supabase generate proper UUIDs
      const cleanPermissions = localPermissions.map(({ id, ...rest }) => rest);
      
      const { error } = await supabase
        .from('role_permissions')
        .insert(cleanPermissions);
      
      if (error) {
        console.error("[PermissionsStorage] Error syncing to database:", error);
        return false;
      }
      
      console.log("[PermissionsStorage] Successfully synced local cache to database");
      return true;
    } else {
      console.log("[PermissionsStorage] Database already has data, skipping sync from local cache");
      return true;
    }
  } catch (error) {
    console.error("[PermissionsStorage] Error syncing to database:", error);
    return false;
  }
};
